import { Flex, FormProvider, PaginationProvider } from 'dash-ui';
import { GetPropertyByIdQuery } from 'gql/generated.graphql';

import PropertyGeneralInfoForm from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/PropertyGeneralInfoForm';
import { FormFieldsList } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

import PropertySlideshow from './components/PropertySlideshow/PropertySlideshow';

function PropertyGeneralInformation({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  return (
    <Flex px={6} py={2} flexDirection="column">
      <FormProvider fieldsList={FormFieldsList}>
        <PropertyGeneralInfoForm property={property} />
        <PaginationProvider>
          <PropertySlideshow property={property} />
        </PaginationProvider>
      </FormProvider>
    </Flex>
  );
}

export default PropertyGeneralInformation;
